import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideSolution() {
  return <Slide data-id="element-249">
      <SlideHeader data-id="element-250">The Solution</SlideHeader>

      <div className="flex-1 flex flex-col justify-center" data-id="element-251">
        <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[90px] font-serif leading-[1.05] tracking-tight mb-6" data-id="element-252">
          Waydev proves they do.
        </motion.h2>
        <motion.p variants={itemVariants} className="text-2xl md:text-3xl text-gray-400 font-light mb-20 max-w-4xl" data-id="element-253">
          Adoption. Impact. ROI. Measured across every agent, every commit,
          every dollar.
        </motion.p>

        <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-800 border border-gray-800" data-id="element-254">
          <div className="bg-black p-8 md:p-12" data-id="element-255">
            <h3 className="text-2xl font-serif mb-4" data-id="element-256">Adoption</h3>
            <div className="h-px w-12 bg-white mb-6" data-id="element-257" />
            <p className="text-gray-400 leading-relaxed" data-id="element-258">
              Track AI weekly active users across Copilot, Cursor, and custom
              agents. Identify power users and adoption bottlenecks.
            </p>
          </div>

          <div className="bg-black p-8 md:p-12" data-id="element-259">
            <h3 className="text-2xl font-serif mb-4" data-id="element-260">Impact</h3>
            <div className="h-px w-12 bg-white mb-6" data-id="element-261" />
            <p className="text-gray-400 leading-relaxed" data-id="element-262">
              Measure AI code shipped to production. Correlate agent usage with
              cycle time reduction and PR merge rates.
            </p>
          </div>

          <div className="bg-black p-8 md:p-12" data-id="element-263">
            <h3 className="text-2xl font-serif mb-4" data-id="element-264">ROI</h3>
            <div className="h-px w-12 bg-white mb-6" data-id="element-265" />
            <p className="text-gray-400 leading-relaxed" data-id="element-266">
              Calculate exact $/PR, $/dev, and tokens per team. Justify
              enterprise licensing costs with hard engineering data.
            </p>
          </div>
        </motion.div>
      </div>
    </Slide>;
}